import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { PolicyMakerNavProvider, usePolicyMakerNav } from '../context/PolicyMakerNavContext';
import Navbar from '../components/Navbar';
import { loadPolicyMakerProfile } from '../utils/policyMakerProfileStorage';

function PolicyMakersWorkspaceShell() {
  const navigate = useNavigate();
  const { setWorkspaceNav } = usePolicyMakerNav() || {};

  useEffect(() => {
    const profile = loadPolicyMakerProfile();
    if (!profile?.ministryDepartmentName?.trim()) {
      navigate('/policy-maker', { replace: true });
      return;
    }
    if (!setWorkspaceNav) return undefined;
    setWorkspaceNav({
      onEditProfile: () => navigate('/policy-maker?setup=1'),
    });
    return () => setWorkspaceNav(null);
  }, [navigate, setWorkspaceNav]);

  return (
    <main className="critical-minerals-dashboard-main w-full">
      <Outlet />
    </main>
  );
}

/** Workspace routes under /policy-makers/* */
const PolicyMakersRouteLayout = () => (
  <PolicyMakerNavProvider>
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200 w-full">
      <Navbar />
      <PolicyMakersWorkspaceShell />
    </div>
  </PolicyMakerNavProvider>
);

export default PolicyMakersRouteLayout;
